<template>
  <div class="supply">
    <div class="edit_supply_warp">
      <van-field
        class="edit_supply_textarea"
        v-model="content"
        type="textarea"
        placeholder="Please add content"
        @input="fieldChange"
        maxlength="800"
        rows="4"
        show-word-limit
      />
      <div class="uploading_wrap">
        <van-uploader
            v-model="fileList"
            multiple
            :max-count="5"
            :before-read="beforeRead"
            :after-read="afterRead"
            @delete ="deleteimg"
            :preview-size="size"
            >
        </van-uploader>
      </div>
      <span style="color:#bfbfbf;">5 pictures at most</span>
      <div class="btn-bg">
        <div class="btn" @click="submitRelease">
          <span>Submit</span>
        </div>
      </div>
    </div>

    <div class="select-topic" v-if="relepase==''">
      <div class="select-topic-box" @click="gotopicsearch">
        <span class="span1">#</span>
        <span>
          选择话题
          <span style="font-size:.22rem">（请至少选择一个话题）</span>
        </span>
        <van-icon name="arrow" style="position: absolute;right: .3rem" />
      </div>
    </div>

    <div class="select-topic" v-else>
      <div class="select-topic-list">
        <span class="lspan">#</span>
        <div class="scroll_view" :scroll-x="true">
          <div style="display: flex">
            <div class="topic-tips" v-for="(item,index) in relepase" :key="index">
              <span class="span-tips-1 van-ellipsis">
                {{item.title}}
              </span>
              <span class="span-tips-2" @click="delete_relepase(index)">X</span>
            </div>
          </div>
        </div>
        <div class="trans"></div>
        <van-icon name="arrow" style="position: absolute;right: .3rem" @click="gotopicsearch" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import gql from 'graphql-tag'
export default {
  name: "editSupply",
  components: {},
  data() {
    return {
      content: "",
      imgList: [],
      isNotPreview: false,
      content1: "",
      relepase: [],
      themeIds: [],
      topicId: "",
      tx_show: true,
      fileList: [],
      imgUrls:[],
      Upimg:[], // 上传的图片
      size:'2.14rem',
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId",
      exhibitionInfo:'getExhibitionInfo'
    }),
    isEdit(){
      return this.$route.query.isEdit||false
    },
    talkId(){
      return this.$route.query.talkId
    }
  },
  created(){
    this.init()
  },
  methods: {
    ...mapActions({
      goTopicsearch: "linkTo/Linktopicsearch",
      TalkRelease: "topicSupply/TalkRelease",
      getTopicOne: "topicSupply/getTopicOne",
      TalkDetail: "topicSupply/TalkDetail",
      EditTalk: "topicSupply/EditTalk",
      goSearch:"linkTo/goSearch"
    }),
    async init(){
      if (localStorage.getItem("relepase")&&JSON.parse(localStorage.getItem("relepase")).length){
          let relepase1=JSON.parse(localStorage.getItem("relepase"))
          this.relepase=this.deteleObject(relepase1) //去除重复的数据
      }
      else if (this.$route.query.topicId){
            console.log(localStorage.getItem("relepase"))

            let topicList = await this.getTopicOne(this.$route.query.topicId);
            this.relepase.push(topicList.data);
            localStorage.setItem("relepase",JSON.stringify(this.relepase))
        }
      else {
        localStorage.setItem("relepase",'')
      }
      //判断是否有缓存的上传图片
      if (localStorage.getItem("Upimg")){
        this.fileList= eval('(' + localStorage.getItem("Upimg") + ')');
        console.log( this.Upimg,' this.Upimg this.Upimg')
        this.Upimg=this.fileList

      }
      //判断是否有缓存的输入文字
      if (localStorage.getItem("content")){
        this.content=localStorage.getItem("content")
      }
      //重新编辑。获取信息
    },

    getTopicId(topicId) {
      this.topicId = topicId;
      this.newRelease();
    },
    deteleObject(obj) {
      let uniques = [];
      let stringify = {};
      for (let i = 0; i < obj.length; i++) {
        let keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        let str = "";
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    fieldChange(e) {
      this.content = e;
      localStorage.setItem("content",this.content)
    },
    async editTalk() {
      let opt = {
        talkId: this.talkId,
        memberId: this.userInfo.id,
      };
      let data = await this.TalkDetail(opt);
      this.talkDetail = data;
      this.content = data.content;
      this.relepase = data.themes[0];
      if (this.talkDetail.imgUrls) {
        this.imgList = data.imgUrls.split(";");
      }
    },
    // 发布话题-讨论
    async submitRelease() {
      if (this.relepase) {
        this.relepase.forEach((v) => {
          console.log(v.id,'v.id')
          this.themeIds.push(v.id);
        });
      }
      console.log(this.themeIds, " this.themeIds");
      if (!this.content) {
        this.$toast.fail('请输入话题内容');
        return;
      }
      if (!this.themeIds || this.themeIds.length == 0) {
        this.$toast.fail('请至少选择一个话题');
        return;
      }
      this.Upimg.map(el=>{
        this.imgUrls.push(el.url)
      })
      if(!this.isEdit) {
        let opt = {
          themeIds: this.themeIds,
          memberId: this.userInfo.inMember.memberId,
          content: this.content,
          exhibitionId:this.exhibitionId,
          imgUrls:this.imgUrls.join(";"),
          orgin:this.exhibitionInfo.exhibition.name,
        };
        let data = await this.TalkRelease(opt);
        if (data && data.result) {
          this.$toast.success({
            message:'发布成功',
            forbidClick:true,
          });
          localStorage.setItem("relepase", '')
          localStorage.setItem("Upimg", '')
          localStorage.setItem("content", '')
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        } else {
          this.$toast.fail('提交失败');
        }
      } else {
        let opt = {
          auditState: 0,
          themeIds: this.themeIds,
          memberId: this.userInfo.inMember.memberId,
          content: this.content,
          id: this.talkId,
          imgUrls:this.imgUrls.join(";")
        };
        let data = await this.EditTalk(opt);
        if (data && data.result) {
          this.$toast.success({
            message:'修改成功',
            forbidClick:true,
          });
          localStorage.setItem("relepase", '')
          localStorage.setItem("Upimg", '')
          localStorage.setItem("content", '')
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        } else {
          this.$toast.fail('修改失败');
        }
      }
    },
    gotopicsearch() {
      if (this.relepase.length < 3) {
        this.goSearch()
      } else {
        this.$toast.fail('最多选择三个话题');
      }
    },
    opentx_show() {
      this.tx_show = true;
    },
    delete_relepase(index) {
      console.log(index, "index");
      this.relepase.splice(index, 1);
      localStorage.setItem("relepase", JSON.stringify(this.relepase))
    },
    viewImg(e) {
      this.isNotPreview = true;
      let imgL = this.imgList;
      imgL = imgL.map((c) => {
        return (c += this.oPotoView);
      });
      // wx.previewImage({
      //   current: e + this.oPotoView, // 当前显示图片的http链接
      //   urls: imgL, // 需要预览的图片http链接列表
      // });
    },
    //删除图片
    clearImg(index) {
      this.imgList.splice(index, 1);

    },
    deleteimg(index){
      console.log(index,'index')
      console.log(this.fileList,'fileList')
      if(index.url){
        this.Upimg=this.fileList
        // this.Upimg= this.Upimg.replace("[",'')
        // this.Upimg=this.Upimg.replace("]",'')
        console.log( this.Upimg,' urlString')
        localStorage.setItem("Upimg",JSON.stringify(this.Upimg))
      }


      console.log(index,'index')

    },
    //上传图片
    async setImg() {
      console.log("aaaaaas");
      this.isNotPreview = true;
      if (this.imgList.length > 5) {
        this.$toast.fail('最多上传五张图片');
        return;
      }
      let that = this;

    },

    beforeRead(file) {
      console.log(file,'上传图片123')
      if(Array.isArray(file)){ // 多张图片
        if(file.length > 5) {
          this.$toast.fail("最多上传5张图片");
        } else {
          let isTrue = true;
          for(var i=0; i<file.length; i++){
            if(!(file[i].type === "image/jpeg" || file[i].type === "image/png")){
              this.$toast.fail("图片格式不对");
              isTrue = false;
              break;
            }
            if(file[i].size > 1024 * 10000){
              this.$toast.fail("图片不能超过10M ");
              isTrue = false;
              break;
            }
          }
          return isTrue;
        }
      } else {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJPG) {
          this.$toast.fail("图片格式不对");
          return false;
        }
  
        if (file.size > 1024 * 10000) {
          //图片不能超过4M
          this.$toast.fail("图片不能超过10M ");
          return false;
        }
        return true;
      }
    },
    afterRead(file) {
      console.log(file, "上传完成");
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });

      if(Array.isArray(file)){ // 多张图片
        for(var i=0; i<file.length; i++){
          this.upFile(file[i]);
          this.$toast.clear();
        }
      } else {
        this.upFile(file);
        this.$toast.clear();
      }
    },
    upFile(file){
       let data = new FormData();
      data.append('multfile', file.file);
      data.append('operaType',null);
      // this.$dialog.loading.open();
      this.$http.post('https://online-api.zhanshangxiu.com/api/v1/file',data)
          .then(res=>{
            // this.Upimg.push(res.data.Data.imgUrls[0])
            console.log(res)
            if (res.data.data){
              this.fileList=[]
              let opt={
                url:res.data.data[0]
              }
              this.Upimg.push(opt)
              localStorage.setItem("Upimg",JSON.stringify(this.Upimg))
              this.Upimg.map(el=>{
                this.fileList.push(el)
              })

              this.show=false;
              this.$toast.clear()
            }

          }).catch(err=>{
            this.$toast.fail('上传失败了！');
            this.$toast.clear()
          })
    },
    // // 上传完成，上传至服务器
    // afterRead(file){
    //   console.log(file,'上传完成');
    //   this.$toast.loading({
    //     message: '上传中...',
    //     forbidClick: true,
    //     duration:0
    //   });
    //   let data = new FormData();
    //   data.append('multfile', file.file);
    //   data.append('operaType',null);
    //   // this.$dialog.loading.open();
    //   this.$http.post('https://online-api.zhanshangxiu.com/api/v1/file',data)
    //                 .then(res=>{
    //                   // this.Upimg.push(res.data.Data.imgUrls[0])
    //                   console.log(res)
    //                   if (res.data.data){
    //                     this.fileList=[]
    //                     let opt={
    //                       url:res.data.data[0]
    //                     }
    //                     this.Upimg.push(opt)
    //                     localStorage.setItem("Upimg",JSON.stringify(this.Upimg))
    //                     this.Upimg.map(el=>{
    //                       this.fileList.push(el)
    //                     })

    //                     this.show=false;
    //                     this.$toast.clear()
    //                   }

    //                 }).catch(err=>{
    //                   this.$toast.fail('上传失败了！');
    //                   this.$toast.clear()
    //                 })
    // },

  },
};
</script>

<style lang="scss" scoped>
.supply {
  width: 100%;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.edit_supply_warp {
  padding: 0 0.24rem 0.24rem;
  color: #fff;
  background: #fff;
    .van-cell {
      padding: .25rem .2rem .1rem;
      margin-bottom: .5rem;
      border-radius: 3px;
      background: #fff;
      overflow-y:initial;
      &::after {
        display: none;
      }
    .van-field__input {
      min-height: 1.3rem;
      color: #333;
    }
    .van-field__word-limit {
      color: #bfbfbf;
    }
    // &::v-deep .van-cell__value{
    //   .van-field__control{
    //     line-height: 0.28rem;
    //     color: #fff;
    //     word-break:break-all;
    //     word-wrap:break-word;
    //     text-align: justify;
    //   }
    // }

  }
  .uploading_wrap {
    display: flex;
    margin-bottom: 0.2rem;
    flex-wrap: wrap;

    .img_block {
      margin-right: 0.2rem;
      position: relative;
      &:nth-child(3) {
        margin-right: 0;
      }
      .img_wrap {
        width: 2.14rem;
        height: 2.14rem;
        border-radius: 1px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .van-icon {
        background: transparent;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
      .img_uploading{
        .van-uploader__upload-icon {
          font-size: .3rem;
        }
        .van-image__img{
          width: 2.14rem;
          height: 2.14rem;
        }
        margin: 0;
        border: 1px  #cccccc dashed;
        display: flex;
        justify-content: center;
        width: 2.14rem;
        height: 2.14rem;
        background-color: #f2f2f2;
        border-radius: .1rem;

      }
      .van-icon-clear {
        font-size: .3rem;
        position: absolute;
        top: 0;
        right: 0;
        font-size: .3rem;
        margin-right: -.15rem;
        margin-top: -.15rem;
        color: #666;
      }
  }
}
.select-topic {
  height: 0.88rem;
  width: 100%;
  margin-top: 0.3rem;
  background-color: #fff;
  span {
    line-height: 0.88rem;
    font-size: 0.3rem;
  }
  &-box {
    padding: 0 0.3rem;
    display: flex;
    position: relative;
    align-items: center;
    .span1 {
      color: #ff5c00;
      font-weight: bold;
      display: inline-block;
      margin-right: 0.2rem;
    }
  }
  &-list{
     padding: 0 .3rem;
     display: flex;
     position: relative;
     align-items: center;
     .lspan{
        color:#ff5c00;
        font-weight:bold;
        display: inline-block;
        margin-right: .2rem;
     }
  }
}
.topic-tips {
  margin-right: 0.2rem;
  height:0.48rem;
  display: flex;
  align-items: center;
  border-radius: 0.24rem;
  background-color: #ffddcc;
  .span-tips-1 {
    padding: 0.14rem 0.2rem;
    padding-right: 0;
    font-size: 0.22rem;
    color: #ff5500;
    display: block;
    max-width: 2rem;
  }
  .span-tips-2 {
    color: #ff5500;
    font-size: 0.22rem;
    margin-right: 0.2rem;
    margin-left: 0.1rem;
    flex: 0;
  }
}
.scroll_view {
  overflow: auto;
  white-space: nowrap;
  width: 6rem;
  position: relative;
}
.trans {
  position: absolute;
  width: 0.6rem;
  height: 0.88rem;
  right: 0.7rem;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
}
.btn-bg {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.98rem;
  width: 100%;
  text-align: center;
}
.btn {
  width: 6.5rem;
  height: 0.78rem;
  background-color: #1890ff;
  border-radius: 0.37rem;
  border: solid 2px #1890ff;
  margin: 0 auto;
  margin-top: 0.1rem;
  span{
      color: #fff;
      font-size: .3rem;
      line-height:.78rem;
  }
}
</style>
